import Icon from '@components/icon';
import cn from 'clsx';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';

import { FollowedLoadsPagination } from 'components/FollowedLoadsPagination';
import { FollowedLoadsPerPageSelect } from 'components/FollowedLoadsPerPageSelect';
import { useStore } from 'hooks/useStore';
import { PrettyLoad } from 'layout/Search/PrettyLoad';
import { TabsContent } from 'layout/TabsContent';

import css from './ContentWithOffers.module.css';

const ContentWithOffers = () => {
  const {
    app: { i18n },
    view,
    followedLoads: { favorites, loadsWithOffers, loadsWithAuctions },
    etrnPromo,
    ui: { pagination, handleTabChange },
  } = useStore();

  const callbacks = useMemo(
    () => ({
      hideLoads: () => {},
      selectLoads: loadsWithOffers.selectedLoads.toggleSelection,
      onRemoveLoadFromFavorites: favorites.updateLoads,
      onAddLoadToFavorites: favorites.updateLoads,
      onOfferChange: loadsWithOffers.updateLoads,
      onCounterOfferSend: etrnPromo.showPopupAfterCounterOffer,
      onAuctionChange: loadsWithAuctions.updateLoads,
      onFilterTabOpen: handleTabChange,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  if (loadsWithOffers.count === 0) {
    return (
      <TabsContent.NoContent
        className={css.noContent}
        desc={''}
        icon={<Icon color="var(--glz-color-neutral-tone-4)" name="ic_hands" size="xl" />}
        title={i18n.favorites.noContent.offers.title}
      />
    );
  }

  return (
    <div>
      <div className={css.heading}>
        <h2 className={cn(css.totalItems, 'glz-h glz-is-size-2')}>
          {view.pluralizedCount(loadsWithOffers.count, 'loads')}
        </h2>

        <FollowedLoadsPagination />
      </div>

      <div className={cn(css.actions, css.actions_top)}>
        <FollowedLoadsPerPageSelect isRow />
      </div>

      <PrettyLoad
        callbacks={callbacks}
        currentPage={pagination.pages.onlyWithOffers}
        descriptor={{ isFavorites: true }}
        loads={loadsWithOffers.loads}
        selectedLoadsIds={loadsWithOffers.selectedLoads.plainIds}
        updateLoad={loadsWithOffers.updateLoad}
      />

      {pagination.totalLoadsWithOffersPages > 1 && (
        <div className={cn(css.actions, css.actions_bottom)}>
          <FollowedLoadsPagination />

          <FollowedLoadsPerPageSelect containerClassName={css.sortField} />
        </div>
      )}
    </div>
  );
};

const connected = observer(ContentWithOffers);

export { connected as ContentWithOffers };
